import _ from 'lodash';
import { formatDate } from 'core/utils';
import moment from 'moment';

class ExportDataMapper {
	constructor() {}

	mapDataByKey = (data, tableDataColumns) => {
		var data = _.map(data.slice(), dataItem => {
			var columns = {};
			_.forEach(tableDataColumns, column => {
				if (column.selected) {
					var splitedKey = column.key.split('.');
					columns[column.key] = this.getValueBySplittedKey(splitedKey, dataItem);
				}
			});

			this.dateConversion(columns);

			return columns;
		});
		return data;
	};

	getValueBySplittedKey(splitedKey, dataItem) {
		switch (splitedKey.length) {
			case 1:
				return dataItem[splitedKey[0]];
			case 2:
				return dataItem[splitedKey[0]] != null ? dataItem[splitedKey[0]][splitedKey[1]] : null;
			case 3:
				return dataItem[splitedKey[0]] != null
					? dataItem[splitedKey[0]][splitedKey[1]] != null
						? dataItem[splitedKey[0]][splitedKey[1]][splitedKey[2]]
						: null
					: null;
			case 4:
				return dataItem[splitedKey[0]] != null
					? dataItem[splitedKey[0]][splitedKey[1]] != null
						? dataItem[splitedKey[0]][splitedKey[1]][splitedKey[2]] != null
							? dataItem[splitedKey[0]][splitedKey[1]][splitedKey[2]][splitedKey[3]]
							: null
						: null
					: null;
			case 5:
				return dataItem[splitedKey[0]] != null
					? dataItem[splitedKey[0]][splitedKey[1]] != null
						? dataItem[splitedKey[0]][splitedKey[1]][splitedKey[2]] != null
							? dataItem[splitedKey[0]][splitedKey[1]][splitedKey[2]][splitedKey[3]] != null
								? dataItem[splitedKey[0]][splitedKey[1]][splitedKey[2]][splitedKey[3]][splitedKey[4]]
								: null
							: null
						: null
					: null;
			default:
				return null;
		}
	}

	dateConversion(columns) {
		Object.keys(columns).forEach(key => {
			if (
				columns[key] != null &&
				(key.toLowerCase().includes('date') || key.toLowerCase() === 'created') &&
				moment(columns[key]).isValid()
			) {
				switch (key) {
					case 'shippingDate':
						columns[key] = formatDate(columns[key], true, 'L');
						break;
					default:
						columns[key] = formatDate(columns[key], true, 'LLL');
						break;
				}
			}
		});
	}
}
export default ExportDataMapper;
